// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Lx1f","buttons":"PendingPaymentAlert_buttons__1BQA-"};